var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrowDown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "6px",
    viewBox: "0 0 11 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icArrowDown") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.58484581,10.66 C5.47947137,10.66 5.38726872,10.6209524 5.30823789,10.5428571 L0,5.31047619 L5.26872247,0.117142857 C5.42678414,-0.039047619 5.67704846,-0.039047619 5.82193833,0.117142857 C5.98,0.273333333 5.98,0.520634921 5.82193833,0.663809524 L1.11960352,5.31047619 L5.86145374,9.99619048 C6.01951542,10.152381 6.01951542,10.3996825 5.86145374,10.5428571 C5.78242291,10.6209524 5.69022026,10.66 5.58484581,10.66 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prospects-Views-Swipe-Copy",
    transform: "translate(-96.000000, -81.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "View",
    transform: "translate(22.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UP_views",
    transform: "translate(72.500000, 7.500000) rotate(-90.000000) translate(-72.500000, -7.500000) translate(69.000000, -5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icArrowDown",
    transform: "translate(3.140000, 19.313866) scale(-1, 1) rotate(180.000000) translate(-3.140000, -19.313866) translate(0.140000, 13.813866)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#7BCB45",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowDown);
export default __webpack_public_path__ + "static/media/icArrowDown.1a548db0497c571a4325b6754dc685da.svg";
export { ForwardRef as ReactComponent };